"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Center = void 0;
var React = require("react");
var Row_1 = require("./Row");
var Center = /** @class */ (function (_super) {
    __extends(Center, _super);
    function Center(props) {
        return _super.call(this, props) || this;
    }
    Center.prototype.render = function () {
        return (React.createElement(Row_1.Row, { height: "100%", justifyContent: "center", alignItems: "center" }, this.props.children));
    };
    return Center;
}(React.Component));
exports.Center = Center;
